import React from "react";
import "../Styles/Footer.css";
import { Link } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

function Footer() {
  return (
    <div className="footer-section">
      <div className="footer-container">
        <div className="ft-info">
          <div className="ft-info-p1">
            <p className="ft-title">Balagne Medical Service</p>
            <p className="footer-description">
              Si vous avez besoin de matériel medical, vous êtes au bon endroit !
            </p>
          </div>
        </div>

        <div className="ft-list" id="contact">
          <p className="ft-list-title">Contact</p>
          <ul className="ft-list-items">
            <li>
              <a href="mailto:contact@balagnemedical.com">contact@balagnemedical.com</a>
            </li>
            <li>
              <a href="tel:0495307856">04 95 30 78 56</a>
            </li>
            <li>
              <a href="tel:0626770707">06 26 77 07 07</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="ft-social">
        <ul className="ft-social-links">
           <li>
            <a href="https://www.linkedin.com/company/balagne-medical-service/" target="_blank" rel="noopener noreferrer" title="LinkedIn">
              <i className="bi bi-linkedin"></i>
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/profile.php?id=61567533334319" target="_blank" rel="noopener noreferrer" title="Facebook">
              <i className="bi bi-facebook"></i>
            </a>
          </li>
     <li>
            <a href="https://www.instagram.com/balagnemedical/?hl=fr" target="_blank" rel="noopener noreferrer" title="Instagram">
              <i className="bi bi-instagram"></i>
            </a>
          </li>
        </ul>
      </div>

      <div className="ft-copyright">
        <p>© 2026 Balagne Medical Service</p>
        <Link to={"/mentions-legales"}>Mentions Légales/ Gérer les cookies</Link>
      </div>
    </div>
  );
}

export default Footer;

